module.exports = __webpack_public_path__ + "images/ui-grid_8f16b81dd400112540ad7bb9a0c65e3d.svg";